import * as z from "zod";
import {
  SemanticTable,
  type SemanticTableName,
} from "../../../semantic-catalog/v1/semantic-catalog-refs";
export const CustomAnalyticsQueryPlanTableNameSchema = z.enum([
  SemanticTable.FulfillmentGroups,
  SemanticTable.FulfillmentGroupShipments,
  SemanticTable.FulfillmentGroupShipmentSurcharges,
  SemanticTable.FulfillmentGroupFulfillmentOrders,
  SemanticTable.Orders,
  SemanticTable.OrderLineItems,
  SemanticTable.ReturnLineItems,
  SemanticTable.Returns,
  SemanticTable.ReturnShipments,
]);

export type CustomAnalyticsQueryPlanTableName = SemanticTableName;

export const CustomAnalyticsQueryPlanFunctionNameSchema = z.enum([
  "abs",
  "array_contains",
  "cardinality",
  "ceil",
  "char_length",
  "coalesce",
  "concat",
  "current_date",
  "current_timestamp",
  "current_utc_timestamp",
  "date_add",
  "date_diff",
  "date_trunc",
  "divide_or_zero",
  "extract",
  "floor",
  "greatest",
  "last_day",
  "least",
  "lower",
  "lpad",
  "mod",
  "nullif",
  "power",
  "replace",
  "right",
  "round",
  "rpad",
  "sign",
  "split_part",
  "substring",
  "trim",
  "upper",
  "primary_return_reason",
  "return_input_answer_comments",
  "secondary_return_reason",
  "if",
  "report_local_date",
  "report_local_timestamp",
]);

export type CustomAnalyticsQueryPlanFunctionName = z.infer<
  typeof CustomAnalyticsQueryPlanFunctionNameSchema
>;

export function isCustomAnalyticsQueryPlanFunctionName(
  fn: string | undefined,
): fn is CustomAnalyticsQueryPlanFunctionName {
  return CustomAnalyticsQueryPlanFunctionNameSchema.safeParse(fn).success;
}

export const CustomAnalyticsQueryPlanCastTypeSchema = z.enum([
  "boolean",
  "date",
  "json",
  "number",
  "string",
  "timestamp",
]);

export type CustomAnalyticsQueryPlanCastType = z.infer<
  typeof CustomAnalyticsQueryPlanCastTypeSchema
>;

export const CustomAnalyticsQueryPlanBinaryOperatorSchema = z.enum([
  "add",
  "subtract",
  "multiply",
  "divide",
]);
